const LOGIN_TYPE = {
    none: 'brak',
    quick: 'szybki',
    full: 'pełny'
};

const MARKET = {
    INDIVIDUAL: 'B2C',
    ORGANIZATION: 'B2B',
    B2C_WWW_REJESTRACJA: 'B2C',
    B2B_WWW_REJESTRACJA: 'B2B'
};

export { LOGIN_TYPE, MARKET };
